// extracted by mini-css-extract-plugin
export default {"header":"Table_header__GUFnw","link":"Table_link__aH2cP","active":"Table_active__5U+o8","inactive":"Table_inactive__ZvpkR"};